import { useOktaAuth } from '@okta/okta-react';
import { useSelector } from 'react-redux';
import { productsSelectors } from '../store/products';
import { RootState } from '../store/store';
import {
  CenterBox,
  LoginButton,
  LoginButtonContainer,
  LoginPageContainer,
  LogoutButton,
  Spinner,
  TitleTypography,
  WelcomeTypography
} from './okta-login.styles';

export function LoginOkta(): JSX.Element {
  const { authState, oktaAuth } = useOktaAuth();

  function login() {
    return oktaAuth.signInWithRedirect();
  }

  return (
    <LoginPageContainer>
      <Spinner sx={!authState || authState.isAuthenticated ? {} : { display: 'none' }} />
      <CenterBox sx={authState && !authState.isAuthenticated ? {} : { visibility: 'hidden' }}>
        <TitleTypography>Homesome</TitleTypography>
        <WelcomeTypography>Welcome</WelcomeTypography>
        <LoginButtonContainer id='login-button-container'>
          <LoginButton id='login-button' onClick={login} disableRipple>
            Sign In
          </LoginButton>
        </LoginButtonContainer>
      </CenterBox>
    </LoginPageContainer>
  );
}

export function LogoutOkta(): JSX.Element {
  const { oktaAuth } = useOktaAuth();
  const errorOccured = useSelector((state: RootState) =>
    productsSelectors.selectError(state.products)
  );

  if (errorOccured && errorOccured.code) {
    const errorStatus: number = Number(errorOccured.code);
    if (errorStatus === 403) {
      logout();
    }
  }

  async function logout() {
    await oktaAuth.signOut();
  }

  return (
    <LogoutButton id='logout-button' onClick={logout} disableRipple>
      Logout
    </LogoutButton>
  );
}
